import { Button } from "@/components/ui/button";
import { Appointment } from "@/features/appointments/types/Appointment";
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { cn } from "@/lib/utils";
import { saveEvent } from "@/utils/apis/user-service";
import { handleExpertRole, handleHourAndMinutes } from "@/utils/Functions";
import { useUserStore } from "@/utils/stores/useUserStore";
import { getDisplayDate } from "../../utils/functions";

interface WidgetCardProps {
    text: string;
    buttonText: string;
    onClick: () => void;
    expertRole?: string,
    consult?: Appointment,
    variant?: "default" | "success" | "warning" | "danger" | "custom";
};

export const WidgetCard: React.FC<WidgetCardProps> = ({
    text,
    buttonText,
    onClick,
    expertRole,
    consult,
    variant = "default",
}) => {
    const { userData } = useUserStore()
    const email = userData.email
    const { sendEvent } = useCreateEvent()
    const onButtonClick = async () => {
        onClick()
        if (!email) return
        saveEvent(
            email,
            "control_panel_widget_button_clicked",
            () => { },
            () => { },
            "control_panel_widget",
        )
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "control_panel_widget_main_action", button_text: buttonText }
        })
    }

    const variantClass = cn(
        "w-full px-[10px] py-[11px] rounded-[5px] border border-solid border-border shadow-platform-new flex items-center justify-between min-h-[50px]",
        {
            "border-border bg-white text-black": variant === "default",
            "border-validation bg-validation-30": variant === "success",
            "border-yellow-500 bg-yellow-50 text-yellow-900": variant === "warning",
            "border-red-500 bg-red-50 text-red-900": variant === "danger",
        }
    );

    return (
        <div className={variantClass}>
            <div className="font-medium">
                <div>{text}</div>
                {expertRole && <div className="text-xxs text-primary">{handleExpertRole(expertRole)}</div>}
            </div>
            {
                buttonText && (
                    <div className="flex items-center gap-4">
                        {consult && <div className="font-medium text-[10px]">
                            <strong>{getDisplayDate(consult)}</strong> <span>{handleHourAndMinutes(consult.date)}</span>
                        </div>}
                        <Button
                            variant={variant === "default" ? "default" : "white"} size={'xs'} className=""
                            onClick={onButtonClick}
                        >
                            {buttonText}
                        </Button>
                    </div>
                )
            }
        </div>
    )
};